import { Input } from 'antd';
import { useField } from 'formik';

const TextInput = (propsC) => {
    const { suffix, placeholder, name, type = "text", size = "default", disabled = false } = propsC;
    const [field, meta] = useField(name);
    return (
        <div className="form-group" style={{ width: "100%" }}>
            <Input
                size={size}
                {...field}
                type={type}
                placeholder={placeholder}
                suffix={suffix ? suffix : null}
                status={meta.touched && meta.error ? "error" : ""}
                disabled={disabled}
            />
            {/* {meta.touched && meta.error && (
                <span className="error-input-message">{meta.error}</span>
            )} */}
        </div>
    );
};

export default TextInput;
